import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';

import { SERVER_URL, APP_CLIENT } from '../constants.js';
import { startSession } from '../session.js';

const RESET_GUIDANCE =
  'If you have forgotten your login details contact Alex or another Admin.';

function Login(props) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [user, setUser] = useState({ email: '', password: '' });
  // Off by default, so staying signed in on a device is always a decision.
  const [keepSignedIn, setKeepSignedIn] = useState(false);

  const handleChange = (event) => {
    setUser({ ...user, [event.target.name]: event.target.value });
  };
      
  const login = () => {
    fetch(SERVER_URL + 'api/v1/auth/authenticate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Client': APP_CLIENT },
      body: JSON.stringify(user)
    })
    .then(response => response.json())
    .then(data => {
      if (data.access_token !== undefined) {
        startSession({
          accessToken: data.access_token,
          refreshToken: data.refresh_token,
          keepSignedIn,
          email: user.email,
          role: data.role,
        });
        setMessage('Login successful!');
        setIsError(false);
        setOpen(true);
        props.onLoginSuccess(user.email, data.role);
      } else {
        setMessage(`Login failed: check your username and password. ${RESET_GUIDANCE}`);
        setIsError(true);
        setOpen(true);
          }
    })
    .catch(err => console.error(err));
  };        
  
  return (
    <div>
      <Stack spacing={2} alignItems="center" mt={2}>
        <TextField name="email" label="Email" onChange={handleChange} />
        <TextField
          type="password"
          name="password"
          label="Password"
          onChange={handleChange}
        />
        <Typography variant="caption" color="text.secondary">
          {RESET_GUIDANCE}
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={keepSignedIn}
              onChange={(e) => setKeepSignedIn(e.target.checked)}
            />
          }
          label={
            <Typography variant="body2">Keep me signed in on this device</Typography>
          }
        />

        <Button variant="outlined" color="primary" onClick={login}>
          Login
        </Button>
      </Stack>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        message={message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        ContentProps={{
          style: { backgroundColor: isError ? '#f44336' : '#4caf50' },
        }}
      />
    </div>
  );
  }

export default Login;